import { render, staticRenderFns } from "./ClientHome.vue?vue&type=template&id=ffad1864&scoped=true"
import script from "./ClientHome.vue?vue&type=script&lang=js"
export * from "./ClientHome.vue?vue&type=script&lang=js"
import style0 from "./ClientHome.vue?vue&type=style&index=0&id=ffad1864&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffad1864",
  null
  
)

export default component.exports